import React, { Component } from 'react';
import { Divider, Icon, Switch, Table, Button, Modal, message } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';

import { getCarousel, deleteCarousel, editCarousel } from '../../../../../../../actions';

class Carousel extends Component {
  componentDidMount() {
    this.props.getCarousel({ inactive: true });
  }

  columns = [{
    title: 'Tiêu đề',
    dataIndex: 'title',
  }, {
    title: 'Ngày tạo',
    dataIndex: 'date',
    // width: 170,
  }, {
    title: 'Kích hoạt',
    dataIndex: 'active',
    // width: 100,
    render: (text, record) => (
      <Switch checked={record.active} size='small' onChange={() => this.handleToggleActive(record.key)} />
    ),
  }, {
    title: 'Tùy chỉnh',
    key: 'action',
    // width: 140,
    render: (text, record) => (
      <span>
        <a role='button' onClick={() => { this.handleEdit(record.key); }}><Icon type="edit" />{' '}Sửa</a>
        <Divider type="vertical" />
        <a role='button' onClick={() => { this.handleDelete(record.key); }}><Icon type="delete" />{' '}Xóa</a>
      </span>
    ),
  }];

  handleEdit = (key) => {
    const carousel = this.props.carousel.carousels.find(item => item._id === key);
    this.props.showEditor(carousel);
  }

  handleToggleActive = (key) => {
    const carousel = this.props.carousel.carousels.find(item => item._id === key);
    if (carousel) {
      this.props.editCarousel({
        carousel: {
          ...carousel,
          active: !carousel.active,
        },
        response: {
          success: async () => {
            message.success('Cập nhật slider thành công');
          },
          failure: async (msg = 'Cập nhật slider không thành công') => {
            message.error(msg);
          },
        },
      });
    }
  }

  handleDelete = (key) => {
    Modal.confirm({
      title: 'Bạn chắc chắn xóa slider',
      onText: 'Xóa',
      okType: 'danger',
      cancleText: 'Hủy',
      onOk: () => {
        this.props.deleteCarousel({
          _id: key,
          response: {
            success: async () => {
              message.success('Xóa slider thành công');
            },
            failure: async (msg = 'Xóa slider không thành công') => {
              message.error(msg);
            },
          },
        });
      },
    });
  }

  render() {
    const { carousel: { loading, carousels } } = this.props;

    const tableData = carousels.map(carousel => ({
      key: carousel._id,
      title: carousel.title || 'Không có tiêu đề',
      date: moment(carousel.createdAt).format('L LT'),
      active: carousel.active,
    }));

    return (
      <div>

        <p style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            type="primary"
            onClick={() => this.props.showEditor(null)}
            style={{ marginTop: '10px' }}
          >
            <Icon type="file-add" />Tạo slider mới
          </Button>
        </p>
      
        <Table loading={loading} columns={this.columns} dataSource={tableData} />

        <p style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            type="primary"
            onClick={() => this.props.showEditor(null)}
            style={{ marginTop: '10px' }}
          >
            <Icon type="file-add" />Tạo slider mới
          </Button>
        </p>
      </div>
    );
  }
}

export default connect(state => ({
  carousel: state.carousel,
}), {
  getCarousel,
  editCarousel,
  deleteCarousel,
})(Carousel);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/HomePage/Tabs/Carousel/CarouselTable.js